<template>
  <div class="pc-container">
    <!-- ===== 筛选区域 ===== -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-row">
        <div class="filter-left">
          <el-input
            v-model="searchKeyword"
            placeholder="请输入货品名称"
            size="medium"
            clearable
            @clear="clearSearch"
            @keyup.enter.native="handleSearch"
            class="search-input"
          />
          <el-button type="primary" size="medium" @click="handleSearch">查询</el-button>
          <el-button size="medium" @click="handleReset">重置</el-button>
        </div>
        <div class="filter-right">
          <el-button size="medium" plain @click="openFilterPopup">
            <i class="el-icon-s-operation"></i> 筛选
          </el-button>
          <el-button type="success" size="medium" @click="handleAdd">
            <i class="el-icon-plus"></i> 新建货品
          </el-button>
        </div>
      </div>
    </el-card>

    <!-- ===== 表格卡片 ===== -->
    <el-card class="table-card" shadow="never">
      <div v-if="loading" class="loading-container">
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div v-else-if="!goodsList || goodsList.length === 0" class="empty-state">
        <i class="el-icon-document" style="font-size: 60px; color: #ccc;"></i>
        <p>暂无货品数据</p>
      </div>
      <template v-else>
        <el-table
          :data="goodsList"
          border
          stripe
          height="56vh"
          style="width: 100%;"
          @row-click="showGoodsDetail"
        >
          <el-table-column prop="comlist_v1" label="名称" min-width="140" show-overflow-tooltip />
          <el-table-column label="图片" width="200" align="center">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.comlist_v8"
                :src="scope.row.comlist_v8"
                fit="cover"
                :preview-src-list="[scope.row.comlist_v8]"
                @click.stop=""
                style="width: 50px; height: 50px; border-radius: 4px;"
              />
              <i v-else class="el-icon-picture-outline" style="font-size: 32px; color: #ccc;"></i>
            </template>
          </el-table-column>
          <el-table-column prop="sh_name" label="品牌商" width="200" align="center" />
          <el-table-column label="上下架" width="80" align="center">
            <template slot-scope="scope">
              <el-tag :type="getOnlineStatusClass(scope.row) === 'online-status' ? 'success' : 'danger'" size="small">
                {{ getOnlineStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="规格" width="200" align="center">
            <template slot-scope="scope">
              <el-tag :type="getSpecTypeClass(scope.row) === 'multi-spec' ? 'warning' : 'info'" size="small">
                {{ getSpecTypeText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="comlist_v5" label="货品分类" width="200" show-overflow-tooltip />
          <el-table-column prop="comlist3" label="创建时间" width="240" />
          <el-table-column prop="total_stock" label="总库存" width="100" align="center" />
        </el-table>

        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
          background
        />
      </template>
    </el-card>

    <!-- ===== 详情弹窗 ===== -->
    <el-dialog
      title="货品详情"
      :visible.sync="showDetailDialog"
      width="700px"
      :close-on-click-modal="false"
      @close="closeDetail"
    >
      <div v-if="currentGoods && currentGoods.id">
        <div class="detail-header">
          <div class="detail-title-row">
            <h4 style="color: #333; margin: 0;">{{ currentGoods.comlist_v1 || '未命名商品' }}</h4>
            <div>
              <el-tag size="small" :type="getOnlineStatusClass(currentGoods) === 'online-status' ? 'success' : 'danger'">
                {{ getOnlineStatusText(currentGoods) }}
              </el-tag>
              <el-tag size="small" :type="getSpecTypeClass(currentGoods) === 'multi-spec' ? 'warning' : 'info'">
                {{ getSpecTypeText(currentGoods) }}
              </el-tag>
            </div>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="detail-body">
          <el-row :gutter="20">
            <el-col :span="12"><span class="label">货品分类：</span>{{ currentGoods.comlist_v5 || '未分类' }}</el-col>
            <el-col :span="12"><span class="label">创建时间：</span>{{ currentGoods.comlist3 || '2023-06-15' }}</el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 12px;">
            <el-col :span="20"><span class="label">总库存：</span>{{ currentGoods.com_all || 0 }} 件</el-col>
          </el-row>

          <div class="spec-section" v-if="currentGoods.specs && currentGoods.specs.length">
            <h4>规格明细</h4>
            <el-table :data="currentGoods.specs" border stripe size="small">
              <el-table-column prop="comlist_v1" label="规格名称" min-width="120"></el-table-column>
              <el-table-column prop="comlist_s1" label="数量" width="100"></el-table-column>
              <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === '上架' ? 'success' : 'danger'" size="mini">
                    {{ scope.row.status }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="no-spec">暂无规格</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetail">关闭</el-button>
      </span>
    </el-dialog>

    <!-- ===== 筛选弹窗 ===== -->
    <el-dialog title="商品筛选" :visible.sync="showFilterDialog" width="600px" :close-on-click-modal="false">
      <el-form label-width="100px" size="small">
        <el-form-item label="所在地区">
          <el-select v-model="selectedProvinceId" placeholder="请选择省" @change="onProvinceChange" clearable>
            <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="selectedCityId" placeholder="请选择市" @change="onCityChange" clearable :disabled="!selectedProvinceId" style="margin-left: 10px;">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-model="selectedDistrictId" placeholder="请选择区" clearable :disabled="!selectedCityId" style="margin-left: 10px;">
            <el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="商品标签">
          <el-select v-model="selectedTagIds" multiple placeholder="请选择商品标签" clearable>
            <el-option v-for="item in goodsTypeList" :key="item.id" :label="item.bfenlei4" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="商品状态">
          <el-radio-group v-model="filterStatus">
            <el-radio label="">全部</el-radio>
            <el-radio label="上架">上架</el-radio>
            <el-radio label="下架">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetFilter">重置</el-button>
        <el-button type="primary" @click="confirmFilter">确认筛选</el-button>
      </span>
    </el-dialog>

    <!-- ===== 新建/编辑弹窗 ===== -->
    <goods-form-dialog
      :visible.sync="formDialogVisible"
      :mode="formMode"
      :goods-id="editingGoodsId"
      @success="onFormSuccess"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import xcxrequest from '@/utils/xcxrequest'
import GoodsFormDialog from './GoodsFormDialog.vue'

export default {
  name: 'JxGoodsList',
  components: { GoodsFormDialog },
  data () {
    return {
      // 经销商列表
      dealerList: [],
      currentJxId: null,

      // 搜索
      searchKeyword: '',
      loading: false,
      goodsList: [],

      // 详情
      showDetailDialog: false,
      currentGoods: {},

      // 筛选
      showFilterDialog: false,
      provinceList: [],
      cityList: [],
      districtList: [],
      selectedProvinceId: null,
      selectedCityId: null,
      selectedDistrictId: null,
      goodsTypeList: [],
      selectedTagIds: [],
      filterStatus: '',
      isFilterMode: false,
      filterParams: {},

      // 表单
      formDialogVisible: false,
      formMode: 'add',
      editingGoodsId: null,

      // 分页
      currentPage: 1,
      pageSize: 10,
      totalPages: 0
    }
  },
  computed: {
    totalItems () {
      return this.totalPages * this.pageSize
    }
  },
  mounted () {
    this.loadProvinceList()
    // 加载商品标签
    this.loadGoodsTypes()
    this.fetchGoodsData()
  },
  methods: {
    // ---------- 加载商品标签 ----------
    async loadGoodsTypes () {
      try {
        const res = await request.post('/goods/goods_goodsType.php')
        if (res && res.code === 0) {
          this.goodsTypeList = res.data || []
        }
      } catch (e) {
        console.error('加载商品标签失败', e)
      }
    },

    // ---------- 数据请求 ----------
    async fetchGoodsData (keepPage = false) {
      if (!keepPage) this.currentPage = 1

      this.loading = true
      try {
        const params = {
          a: 'jxGoodsList',
          jx_id: localStorage.getItem('jx_id'),
          page: this.currentPage,
          page_size: this.pageSize
        }

        if (this.searchKeyword.trim()) {
          params.comlist_v1 = this.searchKeyword.trim()
        }
        if (this.isFilterMode && Object.keys(this.filterParams).length) {
          Object.assign(params, this.filterParams)
        }

        const res = await request.post('/admin/jx_goods.php', params)
        if (res && res.code === '0' && Array.isArray(res.data)) {
          this.goodsList = res.data
          this.goodsList.forEach(item => {
            item.shanjianum = item.specs
              ? item.specs.reduce((sum, mx) => sum + parseInt(mx.comlist_s1_1 || 0), 0)
              : 0
          })
          this.totalPages = parseInt(res.pages) / this.pageSize || 1
        } else {
          this.goodsList = []
          this.totalPages = 0
        }
      } catch (error) {
        console.error('获取经销商商品失败', error)
        this.goodsList = []
        this.totalPages = 0
      } finally {
        this.loading = false
      }
    },

    // ---------- 搜索 ----------
    handleSearch () {
      this.isFilterMode = false
      this.filterParams = {}
      this.fetchGoodsData()
    },
    clearSearch () {
      this.searchKeyword = ''
      this.fetchGoodsData()
    },

    // ---------- 重置 ----------
    handleReset () {
      this.searchKeyword = ''
      this.isFilterMode = false
      this.filterParams = {}
      this.selectedProvinceId = null
      this.selectedCityId = null
      this.selectedDistrictId = null
      this.selectedTagIds = []
      this.filterStatus = ''
      this.fetchGoodsData()
    },

    // ---------- 筛选 ----------
    openFilterPopup () {
      this.showFilterDialog = true
    },
    resetFilter () {
      this.selectedProvinceId = null
      this.selectedCityId = null
      this.selectedDistrictId = null
      this.selectedTagIds = []
      this.filterStatus = ''
      this.filterParams = {}
      this.isFilterMode = false
      this.showFilterDialog = false
      this.fetchGoodsData()
    },
    confirmFilter () {
      const params = {}
      if (this.selectedProvinceId) params.province_id = this.selectedProvinceId
      if (this.selectedCityId) params.city_id = this.selectedCityId
      if (this.selectedDistrictId) params.dist_id = this.selectedDistrictId
      if (this.selectedTagIds.length) params.label_id = this.selectedTagIds.join(',')
      if (this.filterStatus) params.status = this.filterStatus

      this.filterParams = params
      this.isFilterMode = Object.keys(params).length > 0
      this.showFilterDialog = false
      this.fetchGoodsData()
    },

    // ---------- 省市区 ----------
    async loadProvinceList () {
      try {
        const res = await xcxrequest.post('/gouwu/address.php?a=provinces')
        if (res.code === '0') this.provinceList = res.data
      } catch (e) { console.error(e) }
    },
    async onProvinceChange (provinceId) {
      this.selectedCityId = null
      this.selectedDistrictId = null
      this.cityList = []
      this.districtList = []
      if (provinceId) {
        const res = await xcxrequest.post('/gouwu/address.php?a=cities', { province_id: provinceId })
        if (res.code === '0') this.cityList = res.data
      }
    },
    async onCityChange (cityId) {
      this.selectedDistrictId = null
      this.districtList = []
      if (cityId) {
        const res = await xcxrequest.post('/gouwu/address.php?a=districts', { city_id: cityId })
        if (res.code === '0') this.districtList = res.data
      }
    },

    // ---------- 详情 ----------
    showGoodsDetail (item) {
      this.currentGoods = item
      this.showDetailDialog = true
    },
    closeDetail () {
      this.showDetailDialog = false
    },

    // ---------- 编辑 / 删除货品 ----------
    editGoods (id) {
      this.closeDetail()
      this.formMode = 'edit'
      this.editingGoodsId = id
      this.formDialogVisible = true
    },
    async deleteGoods (id) {
      if (this.currentGoods.com_all > 0) {
        this.$message.warning('该货品还有剩余库存，无法删除')
        return
      }
      try {
        await this.$confirm('确定要删除此货品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const workId = localStorage.getItem('work_id') || ''
        const userId = localStorage.getItem('user_id') || ''
        await request.post('/include/goods_jiben_del.php', { id, work_id: workId, user_id: userId })
        this.$message.success('删除成功')
        this.closeDetail()
        this.fetchGoodsData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
          this.$message.error('删除失败')
        }
      }
    },

    // ---------- 新建 ----------
    handleAdd () {
      this.formMode = 'add'
      this.editingGoodsId = null
      this.formDialogVisible = true
    },
    onFormSuccess () {
      this.fetchGoodsData()
    },

    // ---------- 分页 ----------
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchGoodsData(true)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchGoodsData(true)
    },

    // ---------- 工具 ----------
    getOnlineStatusText (item) {
      if (item.specs && item.specs.length) {
        return item.specs.some(spec => spec.status === '上架') ? '上架' : '下架'
      }
      return item.is_online === 1 ? '上架' : '下架'
    },
    getOnlineStatusClass (item) {
      return this.getOnlineStatusText(item) === '上架' ? 'online-status' : 'offline-status'
    },
    getSpecTypeText (item) {
      return item.specs?.length > 1 ? '多规格' : '单规格'
    },
    getSpecTypeClass (item) {
      return item.specs?.length > 1 ? 'multi-spec' : 'single-spec'
    }
  }
}
</script>

<style scoped>
/* ===== 全局容器：移除 flex，改为普通块级流式布局 ===== */
.pc-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;               /* 固定视口高度，与物流页面一致 */
  box-sizing: border-box;
  overflow: auto;             /* 内容过多时滚动 */
}

/* ===== 筛选卡片 ===== */
.filter-card {
  margin-bottom: 16px;        /* 与物流页面的间距一致 */
}

.filter-card .filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.filter-card .filter-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-card .search-input {
  width: 220px;
}

.filter-card .filter-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ===== 表格卡片：移除 flex 依赖，表格高度固定 ===== */
.table-card {
  /* 不再使用 flex 布局，由内容撑开 */
}

.table-card .el-table {
  height: 56vh !important;    /* 固定高度，与物流列表一致 */
  min-height: 300px;          /* 保证最小高度 */
}

.table-card .el-table .el-icon-picture-outline {
  font-size: 32px;
  color: #ccc;
}

.table-card .el-table .el-table__row {
  cursor: pointer;
}

/* ===== 加载 & 空状态 ===== */
.table-card .loading-container,
.table-card .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 56vh;               /* 与表格高度一致 */
  min-height: 300px;
  background: #fff;
  border-radius: 8px;
}

.table-card .loading-container .el-icon-loading {
  font-size: 40px;
  color: #409EFF;
  margin-bottom: 16px;
}

.table-card .empty-state p {
  color: #999;
  margin-top: 12px;
}

/* ===== 分页 ===== */
.table-card .pagination {
  margin-top: 16px;
  text-align: right;
}

/* ===== 详情弹窗 ===== */
.detail-header .detail-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
}

.detail-header .detail-title-row h4 {
  margin: 0;
}

.detail-body .label {
  color: #666;
  font-weight: 500;
}

.detail-body .spec-section {
  margin-top: 20px;
}

.detail-body .spec-section h4 {
  margin: 0 0 12px 0;
  color: #333;
}

.detail-body .no-spec {
  color: #999;
  text-align: center;
  padding: 20px 0;
}

.dialog-footer {
  text-align: right;
}

/* ===== 响应式微调（保留） ===== */
@media screen and (max-width: 1100px) {
  .filter-card .search-input {
    width: 160px;
  }
}

@media screen and (max-width: 820px) {
  .filter-card .filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-card .filter-left {
    justify-content: center;
    flex-wrap: wrap;
  }

  .filter-card .filter-left .search-input {
    width: 140px;
  }

  .filter-card .filter-right {
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>
